import React, { useState } from "react";

const floors = ["Ground Floor", "1st Floor", "2nd Floor", "3rd Floor"];

export default function DineInFloorSwitcher({setTableFloor,getTableFloor,tablefloor}) {

  return (
    <div className="dine-in-floor-switcher">
      {getTableFloor.map((floor) => (
        <button
          key={floor?.id}
          className={`dine-floor-button ${tablefloor?.id === floor?.id ? "active" : ""}`}
          onClick={()=>setTableFloor(floor)}
          type="button"
        >
          {floor?.name}
        </button>
      ))}
    </div>
  );
}
